import { TargetType } from '@verantos-dev/types-common';
import type { ProviderType } from '@verantos-dev/types-common';

import type { UseChatWindowBaseOptions } from '../hooks/useChatWindowBase';

export interface AgentChatConfigOptions {
  provider: ProviderType | (() => ProviderType);
  isOwner?: boolean;
}

export const createAgentChatConfig = ({
  provider,
  isOwner = true,
}: AgentChatConfigOptions): UseChatWindowBaseOptions => ({
  isOwner,
  gateway: {
    stream: {
      messageSender: {
        buildRequestPayload: ({ prompt, displayContent, encodedFile }) => {
          const providerValue = typeof provider === 'function' ? provider() : provider;
          return {
            target: {
              type: TargetType.AGENT,
              provider: providerValue,
            },
            payload: {
              prompt,
              ...(encodedFile ? { file_data: encodedFile } : {}),
            },
          };
        },
      },
    },
  },
});
